import React from 'react';
import useWidthSetter from '../../CustomHooks/useWidthSetter';

const InlineVideo = ({ vidLink, vidLinkM, caption }) => {
  const userWidth = useWidthSetter();

  return (
    <div className="inlineVid">
      <video playsInline autoPlay muted loop width="320" height="240">
        <source src={userWidth <= 768 ? vidLinkM : vidLink} type="video/mp4" />
      </video>
      <p>{caption}</p>
    </div>
  );
};

export default InlineVideo;
